import type { MutationOp, Tactic } from '@wintermute/orchestrator';

/** Tactic palette — used across drift map and rhizome for a consistent legend. */
export const TACTIC_COLOR: Record<Tactic, string> = {
  nostalgia: '#e0a341',
  fear: '#e0574b',
  identity: '#a06ae0',
  authority: '#4a80e0',
  doubt: '#3fb6b0',
};

export const TACTIC_LABEL: Record<Tactic, string> = {
  nostalgia: 'Nostalgia',
  fear: 'Fear',
  identity: 'Identity',
  authority: 'Authority',
  doubt: 'Doubt',
};

export const OP_LABEL: Record<MutationOp, string> = {
  amplify: 'amplify',
  soften: 'soften',
  contradict: 'contradict',
  attribute: 'attribute',
  personalize: 'personalize',
  erode: 'erode',
};
